"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfOneArgumentIsUsed = void 0;
const checkIfOneArgumentIsUsed = (args) => {
    let numArgs = 0;
    Object.values(args).forEach((value) => {
        if (!!value)
            numArgs = numArgs + 1;
        if (numArgs > 1)
            return;
    });
    return numArgs === 1;
};
exports.checkIfOneArgumentIsUsed = checkIfOneArgumentIsUsed;
//# sourceMappingURL=checkArgumentValidity.js.map